import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareLayFlatToDryIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 12.75h-9v-.51c0-.546.444-.99.99-.99h7.019a.99.99 0 0 1 .99.99v.51Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.316 2.25a.75.75 0 0 1 .75.751V21a.75.75 0 0 1-.75.75H3.683a.75.75 0 0 1-.75-.75V3.001c0-.414.337-.751.75-.751h16.633Zm-.75 1.5H4.434v16.5h15.132V3.75Z"
})));

export { productCareLayFlatToDryIcon as default };
//# sourceMappingURL=productCareLayFlatToDryIcon.js.map
